import React, { Component } from 'react';
import { formatNumericHumanDate } from '~/DateTime';
import { DisabledDays } from '~/UI/DatePicker';
import Input from '~/UI/Input/Input';
import LayoutConstraint from '~/UI/LayoutConstraint/LayoutConstraint';

import DatePickerInputPopover from './Popover/DatePickerInputPopover';

interface Props {
	dateValue: Date | null;
	disabledDays?: DisabledDays;
	clearable?: boolean;
	isInvalid: boolean;
	styles: { default: string; invalid: string };
	value: string | string[];
	placeholder?: string;
	formatter(date: Date): string;
	onChange(value: string): void;
}

interface State {
	expand: boolean;
}

export default class DatePickerInput extends Component<Props, State> {
	static defaultProps = {
		dateValue: null,
		clearable: false,
		formatter: formatNumericHumanDate,
		isInvalid: false,
	};

	state = { expand: false };

	containerElement: HTMLSpanElement | null = null;

	popoverHasFocus = false;

	render() {
		const {
			props: { value, dateValue, clearable, placeholder, disabledDays, isInvalid, styles, onChange },
			state: { expand },
		} = this;
		const input = (
			<Input
				isInvalid={isInvalid}
				placeholder={placeholder}
				styles={styles}
				value={value}
				onBlur={this.handleInputBlur}
				onClear={clearable ? () => onChange('') : undefined}
				onFocus={this.handleInputFocus}
				onChange={this.handleChange}
			/>
		);

		return (
			<span ref={(ref) => (this.containerElement = ref)}>
				<LayoutConstraint reference={input}>
					{expand ? (
						<DatePickerInputPopover
							disabledDays={disabledDays}
							value={dateValue}
							onBlur={() => (this.popoverHasFocus = false)}
							onClose={this.handleClosePopover}
							onFocus={() => (this.popoverHasFocus = true)}
							onSelect={this.handleSelect}
						/>
					) : null}
				</LayoutConstraint>
			</span>
		);
	}

	showPopover() {
		if (!this.state.expand) {
			this.setState({ expand: true });
		}
	}

	hidePopover() {
		if (this.state.expand) {
			this.setState({ expand: false });
		}
	}

	handleChange = (event: React.FormEvent<HTMLInputElement>) => {
		this.props.onChange(event.currentTarget.value);
	};

	handleInputFocus = () => {
		this.showPopover();
	};

	handleInputBlur = () => {
		if (this.popoverHasFocus) {
			return;
		}

		this.hidePopover();
	};

	handleSelect = (date: Date) => {
		this.hidePopover();
		this.props.onChange(this.props.formatter(date));
	};

	handleClosePopover = (event: MouseEvent) => {
		if (
			event.target !== this.containerElement &&
			this.containerElement &&
			event.target instanceof HTMLElement &&
			!this.containerElement.contains(event.target)
		) {
			this.hidePopover();
		}
	};
}
